/**
 * @file フック：禁止処理
 */

// ライブラリ読み込み
import { useEffect } from "react";

/**
 * 禁止ユーザー操作をセット
 */
export const useProhibit = () => {
    /**
     * PrintScreen禁止処理
     */
    const fnCancelPrintScreen = (e) => {
        // PrintScreenキーが押された場合、クリップボードに空データを挿入
        if (e.keyCode === 44) {
            navigator.clipboard.writeText("");
            return false;
        }
    };
    /**
     * キーが押された時の処理
     */
    let pressedKey = []; // 押されたキーリスト
    const fnKeydown = (e) => {
        if (e.keyCode && pressedKey.indexOf(e.keyCode) === -1) {
            // 押されたキーリストに追加
            pressedKey = [...pressedKey, e.keyCode];
            // 押されたキーリストにWindowsキー・Mac Commandキーが含まれている場合、画像・動画を非表示にする
            if (pressedKey.indexOf(91) !== -1) {
                document.querySelectorAll("img, video").forEach((element) => {
                    element.classList.add("is-overlay");
                });
            }
        }
    };
    /**
     * キーが離された時の処理
     */
    const fnKeyup = (e) => {
        if (e.keyCode) {
            // 押されたキーリストから削除
            pressedKey = pressedKey.filter((key) => key !== e.keyCode);
            // 押されたキーリストにWindowsキー・Mac Commandキーが含まれていない場合、非表示にした画像・動画を表示する
            if (pressedKey.indexOf(91) === -1) {
                const arrayRemoveOverlay = [];
                const promiseRemoveOverlay = new Promise<void>((resolve) => {
                    arrayRemoveOverlay.push(
                        setInterval(() => {
                            if (document.hasFocus() === true) {
                                setTimeout(() => {
                                    document
                                        .querySelectorAll("img, video")
                                        .forEach((element) => {
                                            element.classList.remove(
                                                "is-overlay"
                                            );
                                        });
                                    resolve();
                                }, 500);
                            }
                        }, 2000)
                    );
                });
                promiseRemoveOverlay.then(() => {
                    clearInterval(arrayRemoveOverlay.shift());
                });
            }
        }
    };
    useEffect(() => {
        // 右クリック禁止
        document.addEventListener(
            "contextmenu",
            (e) => {
                e.preventDefault();
            },
            false
        );
        // コピー禁止
        document.body.addEventListener(
            "copy",
            (e) => {
                e.preventDefault();
            },
            false
        );
        // PrintScreen禁止
        window.addEventListener("keyup", fnCancelPrintScreen);
        // キーが押された時の処理
        window.addEventListener("keydown", fnKeydown);
        // キーが離された時の処理
        window.addEventListener("keyup", fnKeyup);
    }, []);
};
